<div class="gap-[40px] flex flex-col vh-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] relative font-archivo">
  <div *ngIf="isInitialLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215ff] font-archivo text-[18px]">Loading staff...</span>
  </div>

  <ng-container *ngIf="!isInitialLoading">
    <div class="gap-[24px] flex flex-col w-[100%] shrink-0 justify-start items-start self-stretch">
      <button
        type="button"
        class="inline-flex items-center gap-[8px] h-[40px] px-[12px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
        (click)="goBack()"
        aria-label="Back">
        <svg class="w-[16px] h-[16px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>Back</span>
      </button>

      <div class="flex flex-row w-full items-center justify-between gap-4 flex-wrap">
        <div class="flex flex-col gap-2">
          <h1 class="text-[#111215] font-bold font-archivo text-[28px] leading-[32px] m-0">
            Staff Management
          </h1>
          <p class="text-[#444955] font-normal font-archivo text-[18px] leading-[26px] m-0">
            Create, edit, and view staff members with search functionality.
          </p>
        </div>

        <div class="flex flex-row items-center gap-3 flex-wrap justify-end">
          <button
            type="button"
            class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-archivo text-[18px] font-semibold cursor-pointer hover:bg-gray-50"
            (click)="onManageLocations()"
          >
            Manage Locations
          </button>

          <button
            type="button"
            class="rounded-[999px] px-[24px] py-[10px] bg-[#F26F24] text-white font-archivo text-[18px] font-bold cursor-pointer hover:bg-orange-600"
            (click)="onCreateStaff()"
          >
            Create Staff
          </button>
        </div>
      </div>

      <div class="w-full max-w-[400px]">
        <NiTextField
          [label]="'Search staff'"
          [placeholder]="'Search by name or email'"
          [required]="false"
          [disabled]="false"
          [readonly]="false"
          [leftIcon]="'search_lg'"
          [value]="searchText"
          [height]="48"
          [borderRadius]="8"
          [border]="'1'"
          customLabelClasses="font-archivo text-[1.125rem] text-gray-1200 mb-1"
          [padding]="{ top: 12, bottom: 12, left: 40, right: 16 }"
          customInputClasses="text-[20px] h-[48px] w-full rounded-lg font-archivo font-semibold text-gray-900 bg-gray-100 border-gray-300 placeholder:font-archivo placeholder:text-[20px] placeholder:text-gray-400"
          (valueChange)="onSearchInput($event)"
        />
      </div>

      <div *ngIf="errorMessage" class="text-red-600 font-archivo text-[18px]">
        {{ errorMessage }}
      </div>

      <div class="relative w-full">
        <div
          *ngIf="isTableLoading"
          class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/60"
        >
          <div class="loader-spinner w-10 h-10 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
        </div>

        <div *ngIf="!errorMessage && !isTableLoading && staffList.length === 0" class="text-center text-gray-500 py-8 font-archivo text-[18px] w-full">
          No staff members found.
        </div>

        <NiTable
          *ngIf="!errorMessage && staffList.length > 0"
          [columns]="columns"
          [data]="staffList"
          trackByKey="id"
          [pagination]="false"
          emptyMessage="No staff members found."
        >
          <ng-template niTableCell="locations" let-row="row">
            <span
              class="staff-locations-cell"
              [staffLocationsTooltip]="getLocationsText(row)"
            >
              {{ getLocationsText(row) }}
            </span>
          </ng-template>
        </NiTable>
      </div>

      <div
        *ngIf="!errorMessage && showPagination"
        class="flex flex-row items-center justify-between w-full px-2"
      >
        <span class="font-archivo text-[16px] text-gray-600">
          Page {{ currentPage }} of {{ totalPages }} ({{ total }} total)
        </span>

        <div class="flex flex-row items-center gap-4">
          <button
            type="button"
            class="cursor-pointer rounded-[999px] border border-gray-300 bg-white px-[24px] py-[10px] font-archivo text-[18px] hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
            [disabled]="currentPage <= 1 || isTableLoading"
            (click)="onPreviousPage()"
          >
            Previous
          </button>

          <button
            type="button"
            class="cursor-pointer rounded-[999px] border border-gray-300 bg-white px-[24px] py-[10px] font-archivo text-[18px] hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
            [disabled]="currentPage >= totalPages || isTableLoading"
            (click)="onNextPage()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
